import React from 'react';
import { useGoogleTranslateLang } from '../../hooks/useGoogleTranslateLang';
import { getUiTermOverride } from '../../utils/uiTransliteration';

/**
 * TranslatedText
 * Renders a short UI phrase, applying a contextual override when the active
 * Google Translate language would otherwise mistranslate it (e.g. booking
 * "Book"/"Booking" → ಪುಸ್ತಕ instead of ಬುಕ್/ಬುಕಿಂಗ್).
 *
 * - When an override exists for the current language, the text is marked
 *   `notranslate` so Google leaves it alone and we show the correct term.
 * - Otherwise the original text is rendered untouched, so Google Translate
 *   handles it as usual and no other language regresses.
 *
 * Usage: <TranslatedText>My Bookings</TranslatedText>
 */
const TranslatedText = ({ children, className = '', component: Component = 'span', ...rest }) => {
  const lang = useGoogleTranslateLang();
  const text = typeof children === 'string' ? children : '';
  const override = getUiTermOverride(text, lang);

  if (override) {
    return (
      <Component className={`notranslate ${className}`.trim()} translate="no" {...rest}>
        {override}
      </Component>
    );
  }

  return (
    <Component className={className} {...rest}>
      {children}
    </Component>
  );
};

export default TranslatedText;
